// extracted by mini-css-extract-plugin
module.exports = {"box":"servicebooknow_box__dSv7d","visible":"servicebooknow_visible__GwX1A","fadein":"servicebooknow_fadein__O_NlU","loading":"servicebooknow_loading__gkqSu"};